import { useEffect, useRef } from "react";
import { Box } from '@mui/material';
import "./FormLabeledTextField.css"

const FormLabeledTextField = ({ label, value, error, helperText, ...props }) => {
    const containerRef = useRef<HTMLDivElement>(null);
    
    const handleChange = (event) => {
        if (props.updateFunction && (props.index !== undefined) && props.column) {
            props.updateFunction(event.target.value, props.index, props.column)
        } else if (props.updateFunction && (props.index === undefined || !props.column)) {
            props.updateFunction(event.target.value);
        }
    };

    const handleClick = () => {
        if (props.onClick) {
            props.onClick()
        }
    };

    const handleWheel = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    // This is to fully block the scroll wheel from interacting with inputs
    useEffect(() => {
        if (!containerRef.current) {
            return;
        }
        const inputs = containerRef.current.querySelectorAll<HTMLInputElement>('input[type="number"]');
        // Add the event listener to each input
        inputs.forEach((input) => {
            input.addEventListener('wheel', handleWheel, { passive: false });
        });
        // Clean up by removing the event listener from each input
        return () => {
            inputs.forEach((input) => {
            input.removeEventListener('wheel', handleWheel);
            });
        };
    }, [containerRef]);

    const inputValue = value !== null && value !== undefined ? value : '';
    const { disabled, ...inputProps } = props;

    if (props.disabled) {
        return (
            <Box ref={containerRef} style={{
                width: '100%',
                height: '100%',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                gap: 1,
                display: 'inline-flex',
                position: 'relative',
                overflow: 'hidden'
            }}>
                <Box style={{
                    alignSelf: 'stretch',
                    marginBottom: 0
                }}>
                    <div style={{
                        color: '#1A1A1A',
                        fontSize: 10,
                        fontFamily: 'Helvetica Neue LT Std',
                        fontWeight: '400',
                        textTransform: 'capitalize',
                        lineHeight: '16px',
                        letterSpacing: 0.70,
                        wordWrap: 'break-word',
                        position: 'absolute',
                        top: 14,
                        right: 8,
                        background: "white",
                        paddingLeft: "3px",
                        paddingRight: "3px",
                        display: "block",
                        backgroundColor: '#E5E8EC',
                    }}>
                        {label}
                    </div>
                </Box>
                <Box style={{
                    alignSelf: 'stretch',
                    height: 38,
                    paddingLeft: 12,
                    paddingRight: 12,
                    borderRadius: 4,
                    backgroundColor: '#E5E8EC',
                    border: '1px #012A52 solid',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    display: 'flex'
                }}>
                    <Box style={{
                        alignSelf: 'stretch',
                        justifyContent: 'right',
                        alignItems: 'right',
                        gap: 8,
                        height: 36,
                    }}>
                        <input style={{
                            flex: '1 1 0',
                            border: 'none',
                            padding: '10px 2px',
                            boxSizing: 'border-box',
                            outline: 'none',
                            width: '50%',
                            height: '100%',
                            fontSize: 16,
                            backgroundColor: 'transparent'
                        }} {...inputProps} value={inputValue} onChange={handleChange} onClick={handleClick} onWheel={handleWheel} />
                    </Box>
                </Box>
                {error && <div style={{ color: 'red', fontSize: 12, marginTop: 4 }}>{helperText}</div>}
            </Box>
        )
    } else {
        return (
            <Box ref={containerRef} style={{
                width: '100%',
                height: '100%',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                gap: 1,
                display: 'inline-flex',
                position: 'relative',
            }}>
                <Box style={{
                    alignSelf: 'stretch',
                    marginBottom: 0
                }}>
                    <div style={{
                        color: '#1A1A1A',
                        fontSize: 10,
                        fontFamily: 'Helvetica Neue LT Std',
                        fontWeight: '400',
                        textTransform: 'capitalize',
                        lineHeight: '16px',
                        letterSpacing: 0.70,
                        wordWrap: 'break-word',
                        position: 'absolute',
                        top: 14,
                        right: 8,
                        background: "white",
                        paddingLeft: "3px",
                        paddingRight: "3px",
                        display: "block"
                    }}>
                        {label}
                    </div>
                </Box>
                <Box style={{
                    alignSelf: 'stretch',
                    height: 38,
                    paddingLeft: 12,
                    paddingRight: 12,
                    borderRadius: 4,
                    border: '1px #012A52 solid',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    display: 'flex'
                }}>
                    <Box style={{
                        alignSelf: 'stretch',
                        justifyContent: 'right',
                        alignItems: 'right',
                        gap: 8,
                    }}>
                        <input type="number" style={{
                            flex: '1 1 0',
                            border: 'none',
                            padding: '10px 2px',
                            boxSizing: 'border-box',
                            outline: 'none',
                            width: '50%',
                            height: '100%',
                            fontSize: 16,
                            backgroundColor: 'transparent',
                        }} {...inputProps} value={inputValue} onChange={handleChange} onClick={handleClick} onWheel={handleWheel} />
                    </Box>
                </Box>
                {error && <div style={{ color: 'red', fontSize: 12, marginTop: 4 }}>{helperText}</div>}
            </Box>
        )
    }

};

export default FormLabeledTextField;
